



































import { Vue, Component, Prop } from "vue-property-decorator";
import { getIresDeviceDisplayName, IresDevice } from "@/data/models/IresDevice";
import { getCategoryIdFromSerialNumber, getTemplateIdFromSerialNumber } from "@/data/models/DeviceSettingsManager";
import { getTemplate } from "@/data/repository/GenericDeviceRepository";
import { defineCategoriesAndTemplatesClientAccess } from "@/permissions/ClientPermissions";
import { DeviceCategoriesAndTemplatesModule } from "@/store/modules/DeviceCategoriesAndTemplatesModule";

@Component
export default class IresDeviceNameComponent extends Vue {
  @Prop() iresDevice!: IresDevice;

  @Prop({ default: true }) showInventoryNumber!: boolean;
  @Prop({ default: false }) showInventoryNumberOnSeperateLine!: boolean;
  @Prop({ default: false }) iresDeviceOverviewItem!: boolean;

  @Prop() deviceTemplateName!: string;
  @Prop({ default: true }) inventoryNumberFirst!: boolean;
  @Prop() inventoryNumber!: string;

  get isAllowedToDefineOwnDeviceCategoriesAndTemplates() {
    return defineCategoriesAndTemplatesClientAccess();
  }

  get sharedDeviceSettingsJson() {
    return DeviceCategoriesAndTemplatesModule.sharedDeviceCategoriesAndTemplates;
  }

  get isInventoryNumberDifferent() {
    return this.inventoryNumber && this.inventoryNumber !== this.iresDevice.serialNo;
  }

  get localDeviceSettingsJson() {
    return DeviceCategoriesAndTemplatesModule.localDeviceCategoriesAndTemplates;
  }

  get deviceSettingsJson() {
    return this.isAllowedToDefineOwnDeviceCategoriesAndTemplates
      ? this.localDeviceSettingsJson
      : this.sharedDeviceSettingsJson;
  }

  get name() {
    const serialNo = this.iresDevice.serialNo;

    if (this.iresDeviceOverviewItem) {
      const categoryId = getCategoryIdFromSerialNumber(serialNo);
      const templateId = getTemplateIdFromSerialNumber(serialNo);
      const templateName = getTemplate(
        this.deviceSettingsJson,
        categoryId,
        templateId
      )?.deviceName;

      return `${serialNo}  ${templateName}`
    }

    if (!this.showInventoryNumber || this.showInventoryNumberOnSeperateLine) {
      return serialNo;
    }

    return getIresDeviceDisplayName(this.iresDevice, undefined);
  }
}
